<p>generic-accordion-group-v2 works!</p>
